export default {
    AUTH_INAPP: 'authInapp',
    FETCH_SHORT_URL: 'fetchShortUrl',
    FETCH_HOSPITAL_INFOS: 'fetchHospitalInfos',
    FETCH_USER_VISIT_INFOS: 'fetchUserVisitInfos',
    SEND_EVENT_CODE: 'sendEventCode'
}


// WEBPACK FOOTER //
// ./src/constant.js